<template src="./template.html"></template>

<script>
import _ from 'lodash'
import MyAlert from '../../components/alert/MyAlert.vue'
import MyButtons from '../add/Buttons.vue'
import MyTransferType from './MyTransferType.vue'
import MyCurrency from '../../components/MyCurrency.vue'
import MyPersons from '../../components/MyPersons.vue'
import MyFloat from '../../components/MyFloat.vue'
import MyBoxes from '../../components/MyBoxes.vue'
import MyBankaccounts from '../../components/MyBankaccounts.vue'
import MyCosts from '../../components/MyCosts.vue'
import MyIncomes from '../../components/MyIncomes.vue'
import MyComment from '../../components/MyComment.vue'
import MyBalances from '../../components/MyBalances.vue'
import MyLendingTable from './table.vue'
import Mixin from './mixin'

export default {
  name: 'TransferItems',
  props: ['formTitle'],
  mixins: [Mixin],
  components: {
    MyAlert,
    MyButtons,
    MyTransferType,
    MyCurrency,
    MyFloat,
    MyPersons,
    MyBoxes,
    MyBankaccounts,
    MyCosts,
    MyIncomes,
    MyComment,
    MyBalances,
    MyLendingTable,
  },
  data() {
    return {
      submitStatus: null,
      valid: false,
      alert: false,
      idForTg: '',
      prevPerson_id: [null, null],
      prevPrice: 0,
      model: this.getDefaultModel(),
      balance: [{
          current: 0,
          new: 0
        },
        {
          current: 0,
          new: 0
        }
      ],
      originalModel: null,
      isDirty: false,
      stabilizeTimer: null,
    }
  },
  computed: {
    clonedModel() {
      return _.cloneDeep(this.model)
    }
  },
  watch: {
    model: {
      deep: true,
      handler(newVal) {
        // مدیریت isDirty با تاخیر
        if (!this.originalModel) {
          clearTimeout(this.stabilizeTimer)
          this.stabilizeTimer = setTimeout(() => {
            this.originalModel = _.cloneDeep(newVal)
            this.isDirty = false
          }, 300)
        } else {
          this.isDirty = !_.isEqual(newVal, this.originalModel)
        }
        // هر تغییر در مدل = محاسبه بالانس جدید
        this.calcNewBalance()
        // هر تغییر شخص = بروزرسانی بالانس
        newVal.items.forEach((item, idx) => this.setBalance(item.person_id, idx))
      }
    }
  },
  async created() {
    this.formState = this.$route.path.split("/")[2]
    this.route = this.$store.getters.pageInfo.route
    await this.initForm()
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy() {
    clearTimeout(this.stabilizeTimer)
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  methods: {
    async initForm() {
      if (this.formState === 'edit') {
        const mid = this.$route.path.split("/")[3]
        await this.$store.dispatch('getInfo', {
          url: `/api/${this.route}`,
          params: {
            mid
          }
        })
        this.model = this.$store.getters.editData

        const [item1, item2] = this.model.items
        this.prevPerson_id = [item1?.person_id, item2?.person_id]
        this.prevPrice = this.model.type === 'p2p' ?
          +(item1?.lending_value || 0) :
          +(item1?.price || 0)

        await Promise.all([
          this.setBalance(item1?.person_id, 0),
          this.setBalance(item2?.person_id, 1)
        ])
      } else {
        this.model = this.getDefaultModel()
      }
    },

    handleBeforeUnload(event) {
      if (this.isDirty) {
        event.preventDefault()
        event.returnValue = ''
      }
    },

    validateForm() {
      this.$refs.form.validate()
      if (!this.valid) return false

      const [sender, receiver] = this.model.items
      const type = this.model.type

      if ((['t2t', 'p2p'].includes(type)) && sender.person_id === receiver.person_id) {
        alert('حواله دهنده و حواله گیرنده یکسان است')
        return false
      }
      if (type === 'b2b' && sender.bank_account_id === receiver.bank_account_id) {
        alert('حواله دهنده و حواله گیرنده یکسان است')
        return false
      }
      return true
    },

    async onSave(e) {
      if (!this.validateForm() || this.submitStatus === 'PENDING') return

      this.model.items[1].price = +(this.model.items[0]?.price || 0)
      const method = this.formState === 'edit' ? 'PUT' : 'POST'
      const payload = {
        method,
        url: `/api/${this.route}`,
        data: {
          data: this.model
        }
      }
      if (!e?.esc && !window.confirm('آیا مایل به ذخیره سند هستید؟')) return

      try {
        this.submitStatus = 'PENDING'
        await this.$store.dispatch('save', payload)
        const res = this.$store.getters.saveData
        if (res?.insert || res?.update) {
          if (res._id) this.idForTg = res._id
          this.alert = true
          this.originalModel = _.cloneDeep(this.model)
          this.isDirty = false
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.submitStatus = null
      }
    },

    async setBalance(person_id, i) {
      if (!person_id) return
      try {
        const type = this.model.type === 'p2p' ? 'lendingBalance' : 'balance'
        const res = await this.personBalance(person_id, type)
        this.balance[i] = {
          ...this.balance[i],
          current: +(res.balance || 0),
          product: res.product
        }
        this.calcNewBalance()
      } catch (e) {
        console.error(e)
      }
    },

    calcNewBalance() {
      const price = this.model.type === 'p2p' ?
        +(this.model.items[0]?.lending_value || 0) :
        +(this.model.items[0]?.price || 0)

      const isAdd = this.formState === 'add'
      this.balance[0].new = isAdd ?
        this.balance[0].current + price :
        this.recalcSingleBalance(0, price)
      this.balance[1].new = isAdd ?
        this.balance[1].current - price :
        this.recalcSingleBalance(1, -price)
    },

    recalcSingleBalance(index, deltaPrice) {
      const samePerson = this.model.items[index].person_id === this.prevPerson_id[index]
      const crossPerson = this.model.items[0].person_id === this.prevPerson_id[1]

      if (samePerson) return this.balance[index].current - this.prevPrice + Math.abs(deltaPrice)
      if (crossPerson) return this.balance[index].current + this.prevPrice + deltaPrice
      return this.balance[index].current + deltaPrice
    },

    getDefaultModel() {
      return {
        type: 't2t',
        items: [{
          price: ''
        }, {
          price: ''
        }],
        comments: {
          debtor: '',
          creditor: ''
        }
      }
    },

    handleChangeType() {
      this.model.item = this.getDefaultModel().items
      this.balance = [{
        current: 0,
        new: 0
      }, {
        current: 0,
        new: 0
      }]
      this.prevPerson_id = [null, null]
      this.prevPrice = 0
    },

    copyComment() {
      if (!this.model.comments.creditor) {
        this.model.comments.creditor = this.model.comments.debtor
      }
    },
  }
}
</script>

<style lang="scss">
@import '../doc/doc.css';
</style>
